import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name:'home',
    component: () =>
      import("../views/Home.vue"),
  },
  /***
   * Admin route
   */
  {
    path:'/admin',
    name:'admin',
    component:()=> import('../admin/AdminDashboard.vue'),
      children: [
        {
        path:'/admin/home',
        name:'admin-home',
        component:()=> import('../admin/AdminHome.vue'),
        },
        {
          path:'/admin/view_all_users',
          name:'admin-users',
          component:()=> import('../admin/Users.vue'),
          },
          {
            path:'/admin/manage_admins',
            name:'admin-manage-admins',
            component:()=> import('../admin/Admins.vue'),
            },
            {
              path:'/admin/settings',
              name:'admin-settings',
              component:()=> import('../admin/Settings.vue'),
              }
      ]
  },
/***
   * End of Admin route
   */
  // editor dashboard routes
  {
    path:'/editor_dashboard',
    name:'editor-dashboard',
    component: () =>
    import("../editor/EditorDashboard.vue"),
    children: [
      {
        path:'/editor_dashboard/home',
        name:'editor_dashboard_home',
        component: () =>
        import("../editor/DashboardHome.vue"),
      },
      {
        path:'/editor_dashboard/:id/:name',
        name:'category-detail',
        props:true,
        component: () =>
        import("../editor/CategoryAgreement.vue"),
      },
    ]
  },
  // end of editor dashboard routes//
  //start of user route //
  { 
    path:'/user',
    name:'user-dashboard',
    component: () =>
       import("../user/UserDashboard.vue"),
       children: [
         { 
          path:'/user/home',
          name:'user-home',
          component: () =>
          import("../user/Home.vue"),
         },
         { 
          path:'/category/:id/:name',
          name:'submit-agreement',
          props:true,
          component: () =>
          import("../user/SubmitAgreement.vue"),
         },
         { 
          path:'/user/agreements',
          name:'user-agreements',
          component: () =>
          import("../user/MyAgreements.vue"),
         },
       ]
  },
  // end of user route
  { 
    path:'/user/login',
    name:'user-login',
    component: () =>
       import("../auth/Login.vue"),
  },
  { 
    path:'/user/register',
    name:'user-register',
    component: () =>
       import("../auth/SignUp.vue"),
  },
  { 
    path:'/editor/register',
    name:'editor-register',
    component: () =>
       import("../auth/EditorRegister.vue"),
  },
  { 
    path:'/editor/login',
    name:'editor-login',
    component: () =>
       import("../auth/EditorLogin.vue"),
  },
  { 
    path:'/request_password_recovery',
    name:'password-recovery',
    component: () =>
       import("../auth/SendReset.vue"),
  },
  { 
    path:'/password/reset',
    name:'password-reset',
    component: () =>
       import("../auth/ResetPassword.vue"),
  },
  { 
    path:'/admin/login',
    name:'admin_login',
    component: () =>
       import("../admin/apex_admin_login.vue"),
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes
});


router.beforeEach((to, from, next) => {
  if(to.path === '/editor_dashboard'){
    next('/editor_dashboard/home')
  } else {
    next()
  }
})

router.beforeEach((to, from , next)=> {
  if(to.path === '/user') {
    next('/user/home')
  } else {
    next()
  }
})

router.beforeEach((to, from , next)=> {
  if(to.path === '/admin') {
    next('/admin/home')
  } else {
    next()
  }
})

export default router;
